import React, { useEffect, useRef } from 'react';
import Flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { FaCalendarAlt, FaClock } from 'react-icons/fa';

const FlatpickrInput = ({ type, placeholder, name, value, onChange }) => {
  const inputRef = useRef();

  useEffect(() => {
    if (!inputRef.current) return;

    Flatpickr(inputRef.current, {
      enableTime: type === 'time',
      noCalendar: type === 'time',
      dateFormat: type === 'time' ? 'H:i' : 'm/d/Y',
      time_24hr: true,
      defaultDate: value,
      onChange: (selectedDates) => {
        const selectedValue = selectedDates[0];
        onChange?.(selectedValue);
      },
      onReady: () => {
        document
          .querySelector('.flatpickr-calendar')
          ?.classList.add('custom-flatpickr');
      },
    });
  }, [type, value, onChange]);

  return (
    <div className="relative w-full">
      <input
        ref={inputRef}
        type="text"
        placeholder={placeholder}
        className="w-full bg-primary text-white placeholder-[#F0EAF5]/60 px-4 py-2 pr-10 pl-10 rounded-md focus:outline-none"
        readOnly
      />
      <div className="absolute text-lg text-white transform -translate-y-1/2 pointer-events-none left-3 top-1/2">
        {type === 'date' ? <FaCalendarAlt /> : <FaClock />}
      </div>
    </div>
  );
};

export default FlatpickrInput;
